import { createTheme } from "@mui/material";
export const customTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 665,
      md: 1075,
      lg: 1200,
      xl: 1536,
    },
  },
});
